module.exports = __webpack_public_path__ + "static/media/default_thumbnail_640_360.2949188b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnail/default_thumbnail_640_360.jpg
// module id = 312
// module chunks = 2